import { render, staticRenderFns } from "./DropboxResize.vue?vue&type=template&id=c55d2ba6&"
import script from "./DropboxResize.vue?vue&type=script&lang=js&"
export * from "./DropboxResize.vue?vue&type=script&lang=js&"
import style0 from "./DropboxResize.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports